export default "__VITE_ASSET__C2OGxTvh__"